import { styled, theme } from "../../../../../styles/stitches.config"

export const SCheckboxWrapper = styled("div", {
  width: theme.sizes.s6_5,
  height: theme.sizes.s6_5,
})

export const SCheckboxRow = styled("label", {
  display: "flex",
  flexDirection: "row",
  cursor: "pointer",
  fontSize: theme.fontSizes.small,

  "& #checkbox-unchecked": {
    color: theme.colors.textsAlt,
    transition: "color .25s ease-out",
  },

  hover: {
    "& #checkbox-unchecked": {
      color: theme.colors.primary,
    },
  },

  variants: {
    align: {
      start: { alignItems: "flex-start" },
      center: { alignItems: "center" },
      end: { alignItems: "flex-end" },
    },
    bordered: {
      true: {
        paddingTop: theme.space.s5,
        paddingBottom: theme.space.s5,
        paddingRight: theme.space.s6,
        paddingLeft: theme.space.s6,
        borderWidth: theme.sizes.s0_5,
        borderStyle: "solid",
        borderColor: theme.colors.textsAlt,
      },
    },
  },

  defaultVariants: {
    bordered: false,
  },
})

export const SCheckboxedSectionWrapper = styled("div", {
  paddingTop: theme.space.s5,
  paddingBottom: theme.space.s5,
  paddingRight: theme.space.s6,
  paddingLeft: theme.space.s6,
  borderWidth: theme.sizes.s0_5,
  borderStyle: "solid",

  // transition: "height .25s ease-out", TODO nice to have, zatím nefunguje

  variants: {
    open: {
      true: {
        borderColor: theme.colors.secondary,
      },
      false: {
        borderColor: theme.colors.textsAlt,
      },
    },
  },

  defaultVariants: {
    open: "false",
  },
})

export const CheckboxLabel = styled("span", {
  color: theme.colors.texts,
})
